import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { HttpRequest, IRequest } from "../../utilities/HttpRequest";
import { practicesEndpoints } from "../services/practicesEndpoints";
import {
  IDSA,
  IPracticeResults
} from "../../components/RightPanel/Execution/ExecutionDetail/Types";

export const useDSAList = (): UseQueryResult<{ data: IDSA[] }> => {
  return useQuery({
    queryKey: ["dsaList"],
    queryFn: async () => {
      const request: IRequest = practicesEndpoints.getDSAList();
      return HttpRequest.getWithHeader(request);
    },
  });
};

export const usePracticeListFromCDB =
    (cdb: string): UseQueryResult<{data: IPracticeResults[]}> => {
      return useQuery({
        enabled: !!cdb,
        queryKey: ["cdb-",cdb],
        queryFn: async () => {
          const request: IRequest = practicesEndpoints.getPracticeListFromCDB(cdb);
          return HttpRequest.getWithHeader(request);
        },
      });
    };

export const usePracticeListFromDSA =
    (dsa: string): UseQueryResult<{data: IPracticeResults[]}> => {
      return useQuery({
        enabled: dsa.trim().length > 0,
        queryKey: ["dsa-",dsa],
        queryFn: async () => {
          const request: IRequest = practicesEndpoints.getPracticeListFromDSA(dsa);
          return HttpRequest.getWithHeader(request);
        },
      });
    };
